<script>
import utils from '@/utils/common';

import CommonDropdown from '../CommonDropdown.vue';
import BaseCheckbox from '../BaseCheckbox.vue';

export default {
  name: 'ProjectFilesFooterBar',
  components: { CommonDropdown, BaseCheckbox },
  props: {
    filesData: Array,
    selectedFilesData: Array,
    pagedFilesData: Array,
    selectedCategoryFilesData: Array,
  },
  data() {
    return {
      staticSelection: false,
      isOpenedMenu: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.closeMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeMenu);
  },
  computed: {
    menuItems() {
      return [
        { text: 'Переместить', icon: 'arrows-crossed', handler: () => this.clickSelectedMenu('move') },
        { text: 'Скачать', icon: 'arrow-download', handler: () => this.clickSelectedMenu('download') },
        { text: 'Удалить', icon: 'archive', handler: () => this.clickSelectedMenu('delete') }];
    },

    selectedFilesWord() {
      return utils.pluralWord(this.selectedFilesData?.length, 'файл', 'файла', 'файлов');
    },

    selectedFilesStorageSize() {
      const size = this.selectedFilesData.reduce((acc, current) => acc + current.file.size, 0);
      return utils.storageSizeCounter(size);
    },

    isAllFilesSelected() {
      return (!!this.selectedFilesData.length && !this.selectedCategoryFilesData.find(fileData => !fileData.selected));
    },

    isAllPagedFilesSelected() {
      return (!!this.pagedFilesData.length && !this.pagedFilesData.find(fileData => !fileData.selected));
    },

    preValue() {
      return this.getWordEnding(this.selectedFilesData);
    },
  },
  methods: {
    closeMenu(e) {
      if (this.$refs.actions && !this.$refs.actions.contains(e.target)) {
        this.isOpenedMenu = false;
      }
    },

    clickSelectedMenu(action) {
      this.$emit('action', action);
    },

    toggleSelectedFiles(value, isAll = false) {
      this.$emit('toggleSelectedFiles', { value, isAll });
    },

    getWordEnding(selected) {
      if (selected.length === 1) {
        return '';
      }

      return 'о';
    },
  },
};
</script>

<template lang="pug">
.b-selection-bar(:class="{ static: staticSelection }")
  .__actions-container
    .__left-container
      .__selected-prevalue Выбран{{ preValue }}
        span.__selected-value {{ selectedFilesWord }}
      .__selected-size {{ selectedFilesStorageSize.toUpperCase() }}
      .__selected-actions(ref="actions")
        Btn(:disabled="!selectedFilesData.length" ref="dropdown-button"
          @click="isOpenedMenu = !isOpenedMenu" round blue) Действия
        CommonDropdown.ellipsis-menu_dropdown(ref="dropdown" :items="menuItems"
          :isOpened="isOpenedMenu" @click.native="isOpenedMenu = false" dark noTriangle)
    .__right-container
      BaseCheckbox(:value="isAllFilesSelected" :disabled="!selectedCategoryFilesData.length"
        blueChecked label="Все файлы в папке" notColoredLabel @input="toggleSelectedFiles($event, true)")
      BaseCheckbox(:value="isAllPagedFilesSelected" :disabled="!pagedFilesData.length"
        label="Все файлы на странице" notColoredLabel @input="toggleSelectedFiles")
</template>

<style scoped lang="scss">
.selection-bar {
  height: 64px;
  width: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  color: var(--color-white);

  @media (max-width: 1200px) {
    height: 112px;
    align-items: flex-start;
  }

  @media (max-width: 550px) {
    height: 229px;
  }

  &__actions-container {
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 1200px) {
      flex-direction: column;
      padding: 22px 0 25px 0;
    }

    @media (max-width: 550px) {
      padding: 35px 0 25px 0;
    }
  }

  &__left-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 400px;
    @media (max-width: 1200px) {
      width: 100%;
      justify-content: flex-start;
      margin-bottom: 10px;
    }

    @media (max-width: 550px) {
      box-sizing: border-box;
      flex-wrap: wrap;
      padding: 0 10px;
    }
  }

  &__right-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 340px;
    max-width: 100%;

    @media (max-width: 550px) {
      padding-left: 10px;
      margin-top: 20px;
      height: 55px;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
    }
  }

  &__selected-prevalue {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }

  &__selected-value {
    font-weight: 500;
    margin-left: 5px;
    @media (max-width: 1200px) {
      margin-right: 90px;
    }
  }

  &__selected-actions {
    @media (max-width: 1200px) {
      margin: 0 0 0 auto;
    }

    @media (max-width: 550px) {
      margin-top: 30px;
      width: 100%;
    }
  }

  &__selected-size {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;

    @media (max-width: 550px) {
      margin: 0 0 0 auto;
    }
  }
}

.ellipsis-menu_dropdown {
  top: -140px;
}
</style>
